import React from 'react'

import messageStyles from "./Message.module.css"

import warningIcon from "../../images/warning-icon.png"

export default function Message({ children, type }) {
    return(       
        <div className={messageStyles[`${type}`]}>
            {
                type === "warning" &&
                    <img src={warningIcon} alt="Warning" />
            }               
            <div className={messageStyles.text}>{children}</div>
        </div>
    )
}